<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="progress">
          <div v-if="completed !== undefined" class="progress-bar bg-green" role="progressbar" :style="'width:' + completedPercent + '%'"
               :aria-valuenow="completed"
               :aria-valuemin="0"
               :aria-valuemax="total">
            <span class="d--md-block d-none">{{ `${completed} ${$t('surveyProgress.completed')}` }}</span>
          </div>
          <div v-if="inRevision !== undefined" class="progress-bar bg-blue" role="progressbar" :style="'width:' + inRevisionPercent + '%'"
               :aria-valuenow="inRevision"
               :aria-valuemin="0"
               :aria-valuemax="total">
            <span class="d--md-block d-none">{{ `${inRevision} ${$t('surveyProgress.inRevision')}` }}</span>
          </div>
          <div v-if="returned !== undefined" class="progress-bar bg-orange" role="progressbar" :style="'width:' + returnedPercent + '%'"
               :aria-valuenow="returned"
               :aria-valuemin="0"
               :aria-valuemax="total">
            <span class="d--md-block d-none">{{ `${returned} ${$t('surveyProgress.returned')}` }}</span>
          </div>
          <div v-if="inProgress !== undefined" class="progress-bar bg-yellow" role="progressbar" :style="'width:' + inProgressPercent + '%'"
               :aria-valuenow="inProgress"
               :aria-valuemin="0"
               :aria-valuemax="total">
            <span class="d--md-block d-none">{{ `${inProgress} ${$t('surveyProgress.inProgress')}` }}</span>
          </div>
          <div class="progress-bar bg-empty" role="progressbar" :style="'width:' + pendingPercent + '%'"
               :aria-valuenow="pending"
               :aria-valuemin="0"
               :aria-valuemax="total">
            <span class="d--md-block d-none">{{ `${pending} ${$t('surveyProgress.pending')}` }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="d--md-none d-block mt-2">
      <div class="row" v-if="completed !== undefined && (!onlyShowApplicable || completed > 0)">
        <div class="col">
          <div class="line-status-legend bg-green rounded"></div>
          <div class="d-inline text-left align-middle pl-3">
            {{ `${completed} ${$t('surveyProgress.completed')}` }}
          </div>
        </div>
      </div>
      <div class="row" v-if="inRevision !== undefined && (!onlyShowApplicable || inRevision > 0) && hasWorkflow">
        <div class="col">
          <div class="line-status-legend bg-blue rounded"></div>
          <div class="d-inline text-left align-middle pl-3">
            {{ `${inRevision} ${$t('surveyProgress.inRevision')}` }}
          </div>
        </div>
      </div>
      <div class="row" v-if="returned !== undefined && (!onlyShowApplicable || returned > 0) && hasWorkflow">
        <div class="col">
          <div class="line-status-legend bg-orange rounded"></div>
          <div class="d-inline text-left align-middle pl-3">
            {{ `${returned} ${$t('surveyProgress.returned')}` }}
          </div>
        </div>
      </div>
      <div class="row" v-if="inProgress !== undefined && (!onlyShowApplicable || inProgress > 0)">
        <div class="col">
          <div class="line-status-legend bg-yellow rounded"></div>
          <div class="d-inline text-left align-middle pl-3">
            {{ `${inProgress} ${$t('surveyProgress.inProgress')}` }}
          </div>
        </div>
      </div>
      <div class="row" v-if="!onlyShowApplicable || pending > 0">
        <div class="col">
          <div class="line-status-legend bg-empty rounded"></div>
          <div class="d-inline text-left align-middle pl-3">
            {{ `${pending} ${$t('surveyProgress.pending')}` }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  'name': 'AppProgress',
  'props': {
    'completed': Number,
    'inProgress': Number,
    'inRevision': Number,
    'returned': Number,
    'total': {
      'type': Number,
      'required': true,
      'default': 0
    },
    'onlyShowApplicable': {
      'type': Boolean,
      'default': false
    },
    'hasWorkflow': {
      'type': Boolean,
      'default': false
    },
  },
  'computed': {
    completedPercent() {
      return this.completed !== undefined ? ((this.completed / this.total) * 100) : 0
    },
    inRevisionPercent() {
      return this.inRevision !== undefined ? ((this.inRevision / this.total) * 100) : 0
    },
    inProgressPercent() {
      return this.inProgress !== undefined ? ((this.inProgress / this.total) * 100) : 0
    },
    returnedPercent() {
      return this.returned !== undefined ? ((this.returned / this.total) * 100) : 0
    },
    pending() {
      return this.total - (this.inProgress ?? 0) - (this.inRevision ?? 0) - (this.completed ?? 0) - (this.returned ?? 0)
    },
    pendingPercent() {
      return 100 - this.completedPercent - this.inRevisionPercent - this.inProgressPercent - this.returnedPercent
    }
  }
}
</script>

<style scoped>
  .line-status-legend {
    display: inline-block;
    width: 25px;
    height: 8px;
  }

  .progress-bar {
    font-weight: bold;
  }

  .progress-bar.bg-empty {
    background-color: #e9ecef;
    color: #212529;
  }

  .line-status-legend.bg-empty {
    background-color: #e9ecef;
  }
</style>
